<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import { shuffle } from './utils.ts';

    export let question: string;
    export let answers: string[];
    // Make a shallow copy to prevent shuffling from changing the value in the
    // `quiz` array in App.svelte.
    $: answers = [...answers];

    const dispatch = createEventDispatcher();

    // Store a copy of the original string, as the array will be shuffled
    // randomly
    let correct_answer: string;
    $: correct_answer = answers[0].slice();
    $: shuffle(answers);
    let correct_answer_index: number;
    $: correct_answer_index = answers.indexOf(correct_answer);
    let selected_answer_index: number = -1;

    function recordAnswer(event: Object) {
        selected_answer_index = event.target.dataset.answerIndex;
        setTimeout(
            () => {
                dispatch('answerMsg', { correct: selected_answer_index == correct_answer_index });
                selected_answer_index = -1;
            },
            1200);
    }
</script>

{#key [question, ...answers]}
<p class="wrapper question">{@html question}</p>
<ul class="answers">
{#each answers as answer, index(answer)}
    <li class="u-action"
        data-answer-index={index}
        class:correctAnswer={selected_answer_index == index && selected_answer_index == correct_answer_index}
        class:incorrectAnswer={selected_answer_index == index && selected_answer_index != correct_answer_index}
        on:click={recordAnswer}>
        {@html answer}
    </li>
{/each}
</ul>
{/key}

<style lang="scss">
    @import './styles/Question.scss';
</style>
